<a mat-icon-button [matMenuTriggerFor]="notificationMenu" (menuClosed)="close()" *ngIf="notifications.length > 0">
    <mat-icon [matBadge]="unreadNotificationCount" [matBadgeHidden]="unreadNotificationCount <= 0" matBadgeColor="warn">notifications</mat-icon>
</a>

<mat-menu #notificationMenu="matMenu" class="notification-menu">
    <button mat-menu-item *ngFor="let item of notifications; let last = last" (click)="open(item)">
        <span [innerHtml]="item.content"></span>
    </button>
</mat-menu>